export var isRef = function (obj) {
    return obj && 'current' in obj;
};
